import axios from "axios";

export const getNetworksConnection = async() => {
      var config = {
        method: 'get',
        url: `https://tools.iplocation.net/main/getIPsidebar`,
        headers: { 
          'Content-Type': 'application/json'
        }
      };
      const response = await axios(config);
        return response;
}

